export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const lsColorPrimary = "#EB6F00";
export const lsColorGreen = "#0CA034";

export const lsColorWhite = "#FFF";
export const lsColorGray = "#707070";

export const actionMeaning = {
    REJECTED: "Rechazado",
    ACCEPTED: "Aceptado",
};

export const LS_AUTH_TOKEN_KEY = "ls_auth_token";
export const LS_VERIFY_EMAIL_KEY = "ls_verify_email";

// URL de descarga de la app para México (/mx/descargas)
export const MX_APP_WIN_DOWNLOAD_URL = "https://localshop-site.s3.us-east-1.amazonaws.com/download/int/Localshop_windows_installer.exe";
export const MX_APP_MAC_DOWNLOAD_URL = "https://localshop-site.s3.us-east-1.amazonaws.com/download/int/localshop_pos.app.zip";
